export default __webpack_public_path__ + "static/five-image-145146369b0b3c9ed4e380990f9f7d06.png";